import styled from '@emotion/styled';
import {
  ImageWrapper,
  Sidebar,
} from '@zola/zola-ui/src/components/PreAuthV3/Differentiation.styles';

export const Container = styled.div`
  ${ImageWrapper}, ${Sidebar} {
    border-bottom: 0;
  }
`;
